<template>
  <div class="info">
    <div class="info-content">
      <div class="left">
        <div class="l-t">
          <div class="title">2022年上海船舶系统职工新年文化礼包采购项目招标公告</div>
          <p class="time">2021-11-15</p>
        </div>
        <div class="left-c">
          <img src="./img/01.jpg" alt="">
          <img src="./img/02.jpg" alt="">
          <img src="./img/03.jpg" alt="">
          <img src="./img/04.jpg" alt="">
        </div>
      </div>
      <div class="right">
<!--        <div class="r-c">-->
<!--          <div class="fts-20 title">采购信息发布</div>-->
<!--          <p class="fts-18">企业和个人采购需求信息发布</p>-->
<!--          <p class="fts-18 mt-20">收费标准：600元/千条</p>-->
<!--          <p class="fts-18">收费方式：对公转账</p>-->
<!--          <p class="fts-18 mt-20">发布信息请致电01088589100</p>-->
<!--          <p class="fts-18">联系人：范老师</p>-->
<!--          <p class="fts-18 mt-20">请您通过网银转账，或自行到银行进行汇款，汇款账号如下：</p>-->
<!--          <p class="fts-18">户 名：北京正采信息技术研究院有限公司</p>-->
<!--          <p class="fts-18">账 号：0200207709200084916</p>-->
<!--          <p class="fts-18">开户行：中国工商银行股份有限公司北京西四环支行</p>-->
<!--          <p class="fts-18">行 号：102100020778 (非必填)</p>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";

export default {
  name: "info1",
  created() {
    let temp = localStorage.getItem("wzId3")
    if (temp != 3) {
      router.replace("/")
    }
  },
  unmounted() {
    localStorage.removeItem("wzId3")
  }
};
</script>

<style lang="scss" scoped>
.w-1 {
  width: 100px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
}
.w-2 {
  width: 300px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
}
.text-r {
  text-align: right;
}
.info {
  background-color: #f1f1f1;
  padding-bottom: 90px;
  min-width: 1200px;
  .info-content {
    width: 1200px;
    margin: auto;
    display: flex;
    padding-top: 40px;
    .left {
      width: 840px;
      .left-c {
        padding: 20px;
        img {
         width: 100%;
        }
      }
      .l-t {
        border-bottom: 1px solid #bbbbbb;
        padding: 20px 20px;
      }
      .title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
      }
      .time {
        font-size: 16px;
        text-align: center;
        margin-top: 8px;
      }
    }
    .right {
      width: 360px;
      padding: 20px 0 0 15px;
      position: relative;
      .r-c {
        width: 320px;
        background-color: #089CB0;
        //height: 430px;
        padding: 30px 10px;
        border-radius: 8px;
        box-sizing: border-box;
        color: #ffffff;

        position: fixed;
        p {
          margin: 2px 0;
        }
        .title {
          //font-weight: 800;
        }
        .mt-20 {
          margin-top: 15px;
        }
        .fts-20 {
          font-size: 20px;
        }
        .fts-18 {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
